import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { LoadingComponent } from "../../Components/Loading";
import routes from "../../Helpers/Routes.json";
import { useContext } from "react";
import { Context } from "../../Shared/Context/GlobalContext";

export const ProcessingPaymentPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { resetCart } = useContext(Context);

  useEffect(() => {
    if (!params.transaction) return;

    let timer = null;

    async function poll() {
      timer = setTimeout(async () => {
        const response = await fetch(
          process.env.REACT_APP_API_HOST + `/api/payment/${params.transaction}/status`
        );

        if (response.status === 200) {
          const { data } = await response.json();

          switch (data.status) {
            case "paid":
              resetCart();
              navigate(
                routes.Payment.success.replace(":transaction", data.order)
              );
              return;
            case "error":
            case "refunded":
              navigate("/");
              return;
            default:
          }
        }
        poll();
      }, 2000);
    }

    poll();

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  return <LoadingComponent />;
};
